import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { filterMenuItems } from "../../Hooks/permissionsMiddleware";

const sidebarData = [
  {
    title: "Dashboard",
    icon: "ni ni-app",
    iconColor: "text-info",
    link: "/dashboard",
    // requiredPermissionID: 101 // Permission ID for Dashboard
  },
  {
    title: "Create Booking",
    icon: "ni ni-app",
    iconColor: "text-danger",
    link: "/new-sale",
    requiredPermissionID: 1, // Permission ID for creating new sale
  },
  {
    title: "Bookings",
    icon: "ni ni-basket",
    iconColor: "text-success",
    requiredPermissionID: 2, // Permission ID for viewing sales history
    children: [
      {
        title: "All Bookings",
        link: "/sales-history",
        requiredPermissionID: 2,
      },
      {
        title: "Check In",
        link: "/sales-history/check-in",
        requiredPermissionID: 2,
      },
      {
        title: "Check Out",
        link: "/sales-history/check-out",
        requiredPermissionID: 2,
      },
    ],
  },
  {
    title: "Internal stock requests",
    icon: "fa fa-check",
    iconColor: "text-success",
    link: "/stock-approval",
    requiredPermissionID: 2004, // Permission ID for viewing sales history
  },
  {
    title: "Manage Users",
    icon: "ni ni-settings-gear-65",
    iconColor: "text-orange",
    link: "/manage-users",
    requiredPermissionID: 44,
    children: [
      {
        title: "Add User",
        link: "/manage-users/add-user",
        requiredPermissionID: 44,
      },
      {
        title: "Existing Users",
        link: "/manage-users/existing-users",
        requiredPermissionID: 44,
      },
      {
        title: "Pending Credit Accounts",
        link: "/manage-users/pending-credit-accounts",
        requiredPermissionID: 44,
      },
    ],
  },
  {
    title: "Customers & Companies ",
    icon: "ni ni-single-02",
    iconColor: "text-pink",
    link: "/customers",
    requiredPermissionID: 19, // Permission ID for accessing customers
  },
  {
    title: "Services",
    icon: "ni ni-collection",
    iconColor: "text-success",
    link: "/service",
    // requiredPermissionID: 21, // Permission ID for services
    children: [
      {
        title: "Category",
        link: "/service/category",
        requiredPermissionID: 21, // Permission ID for service category
      },
      {
        title: "Brands",
        link: "/service/brands",
        requiredPermissionID: 22, // Permission ID for managing brands
      },
      {
        title: "Services/Products Type",
        link: "/service/products-type",
        requiredPermissionID: 23, // Permission ID for products type
      },
      {
        title: "Manage services/products",
        link: "/service/products",
        requiredPermissionID: 24, // Permission ID for managing products
      },
      {
        title: "Inventory/Rate Chart",
        link: "/service/rate-chart",
        requiredPermissionID: 25, // Permission ID for rate chart
      },
    ],
  },
  {
    title: "Suppliers",
    icon: "ni ni-box-2",
    iconColor: "text-success",
    link: "/supplier",
    requiredPermissionID: 26, // Permission ID for suppliers section
    children: [
      {
        title: "Suppliers",
        link: "/supplier",
        requiredPermissionID: 26, // Permission ID for viewing suppliers
      },
      {
        title: "Category",
        link: "/supplier/category",
        requiredPermissionID: 28, // Permission ID for supplier categorys
      },
      {
        title: "Products",
        link: "/supplier/products",
        requiredPermissionID: 29, // Permission ID for supplier products
      },
      {
        title: "External stock requests",
        link: "/supplier/stock-requisitions",
        requiredPermissionID: 30, // Permission ID for stock requisitions
      },
    ],
  },
  {
    title: "Reports",
    icon: "ni ni-chart-bar-32",
    iconColor: "text-warning",
    link: "/reports",
    requiredPermissionID: 31, // Permission ID for reports section
    children: [
      // {
      //   title: 'Daily Report',
      //   link: '/reports/daily-reports',
      //   requiredPermissionID: 31 // Permission ID for daily reports
      // },
      {
        title: "Order Report",
        link: "/reports/order-reports",
        requiredPermissionID: 32, // Permission ID for order reports
      },
      {
        title: "Sales Report",
        link: "/reports/sales-reports",
        requiredPermissionID: 33, // Permission ID for sales reports
      },
      // {
      //   title: 'Product/ Service Report',
      //   link: '/reports/service-reports',
      //   requiredPermissionID: 35 // Permission ID for service reports
      // },
      {
        title: "Customer Order Report",
        link: "/reports/customer-order-report",
        requiredPermissionID: 36, // Permission ID for customer order reports
      },

      {
        title: "Inventory Report",
        link: "/reports/inventory-report",
        requiredPermissionID: 38, // Permission ID for inventory reports
      },
      {
        title: "Daily Occupancy Report",
        link: "/reports/daily-occupancy-reports",
        requiredPermissionID: 39, // Permission ID for daily occupancy reports
      },
      {
        title: "Credit Reports",
        link: "/credit/credit-report",
        requiredPermissionID: 3005, // Permission ID for credit reports
      },
      {
        title: "Download All Reports",
        link: "/reports/all-reports",
        requiredPermissionID: 1005, // Permission ID for daily occupancy reports
      },
    ],
  },
  {
    title: "Tools",
    icon: "ni ni-settings-gear-65",
    iconColor: "text-orange",
    link: "/tools",
    requiredPermissionID: 40, // Permission ID for tools section
    children: [
      {
        title: "Financial Year",
        link: "/tools/financial-year",
        requiredPermissionID: 40, // Permission ID for financial year
      },
      {
        title: "Mail Settings",
        link: "/tools/mail-settings",
        requiredPermissionID: 41, // Permission ID for mail settings
      },
      {
        title: "Master Settings",
        link: "/tools/master-settings",
        requiredPermissionID: 42, // Permission ID for master settings
      },
      {
        title: "File Tools",
        link: "/tools/file-tools",
        requiredPermissionID: 43, // Permission ID for file tools
      },
      {
        title: "Outlets",
        link: "/tools/outlets",
        // requiredPermissionID: 45 // Permission ID for outlets
      },
      {
        title: "Roles",
        link: "/tools/roles",
        // requiredPermissionID: 48 // Permission ID for roles
      },
    ],
  },
  {
    title: "Create Credit Note ",
    icon: "fa fa-bank",
    iconColor: "text-warning",
    link: "/credit/credit-note",
    requiredPermissionID: 3008, // Permission ID for tools section
  },
  {
    title: "Credit Management",
    icon: "fa fa-credit-card-alt",
    iconColor: "text-success",
    link: "/tools",
    requiredPermissionID: 3002, // Permission ID for tools section
    children: [
      {
        title: "View Account",
        link: "/credit/view-account",
        requiredPermissionID: 3002, // Permission ID for financial year
      },
      {
        title: "Add/Edit Account",
        link: "/credit/add-account",
        requiredPermissionID: 3003, // Permission ID for mail settings
      },
      // {
      //   title: "Credit Note",
      //   link: "/credit/credit-note",
      //   requiredPermissionID: 3008, // Permission ID for master settings
      // },
      {
        title: "Credit Reports",
        link: "/credit/credit-report",
        // Changed from 3005 so it also appears for users with general Reports access
        requiredPermissionID: 3005, // Permission ID for reports section (was 3005)
      },
    ],
  },
  {
    title: "Restaurant & Bar Sales",
    icon: "fa fa-coffee",
    iconColor: "text-success",
    link: "/beverage-sales",
    requiredPermissionID: 3006, // Permission ID for beverage sales section
    children: [
      {
        title: "Food & Drinks",
        link: "/beverage-sales/bar-sale",
        requiredPermissionID: 3006, // Permission ID for financial year
      },
    ],
  },
];
const Dropdown = ({ elem, open }) => {
  const location = useLocation();
  const [openDropdown, setDropdown] = useState(open);

  useEffect(() => {
    if (elem.children?.some((child) => location.pathname === child.link)) {
      setDropdown(true); // Open dropdown if visiting a child page
    }
  }, [location.pathname, elem.children]);

  return (
    <li className="nav-item">
      {!elem.children ? (
        <NavLink
          className="nav-link"
          to={elem.link}
          isActive={(match, location) =>
            match && location.pathname === elem.link
          }
        >
          <div className="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i
              className={`${elem.icon} ${elem.iconColor} text-sm opacity-10`}
            />
          </div>
          <span className="nav-link-text ms-1">{elem.title}</span>
        </NavLink>
      ) : (
        <NavLink
          className={`nav-link ${elem.children.length <= 0 && "d-none"}`}
          to={elem.link && elem.link}
          data-bs-toggle="collapse"
          onClick={(event) => {
            event.preventDefault();
            setDropdown(!openDropdown);
          }}
        >
          <div className="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i
              className={`${elem.icon} ${elem.iconColor} text-sm opacity-10`}
            />
          </div>
          <span className="nav-link-text ms-1">{elem.title}</span>
        </NavLink>
      )}
      {/* SUBMENUS */}
      {elem.children && (
        <div
          className={!openDropdown ? `collapse` : `collapse show`}
          id="services"
        >
          <ul className="nav ms-4">
            {elem.children.map((elem, i) => {
              return (
                <li className="nav-item" key={i}>
                  <NavLink
                    className={({ isActive }) =>
                      `nav-link ${isActive ? "active" : ""}`
                    }
                    to={elem.link}
                  >
                    <span className="sidenav-normal side-bar-inner">
                      {elem.title}
                    </span>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </li>
  );
};

const Sidebar = ({ collapsed }) => {
  const user = useSelector((state) => state.auth.user);

  // Filter sidebar data based on permissions
  const filteredSidebarData = filterMenuItems(sidebarData);

  return (
    <div
      className="sidenav bg-white navbar navbar-vertical navbar-expand-xs border-0"
      style={{
        paddingTop: "16px",
        position: "fixed",
        top: "64px", // Match your header height
        bottom: 0,
        left: 0,

        overflowY: "auto",
        zIndex: 1000,
        // borderColor: "#000",
        // borderWidth: "0px",
        // borderStyle: "solid",
      }}
    >
      <div
        className="navbar-collapse w-auto h-auto h-100"
        id="sidenav-collapse-main"
      >
        <ul className="navbar-nav">
          {filteredSidebarData.map((elem, i) => (
            <Dropdown elem={elem} open={false} key={i} />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
